import { useContext } from "react";
import { ToastContext } from "../providers/ToastProvider";

export const useToast = () => {
  return useContext(ToastContext);
};
